import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { uniqueId, cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { texts } from '../../utils/Localization.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './Icon.styles.js';

/* tslint:disable:no-console */

var IconPresentation = fComp(function (_ref) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3;

  var icon = _ref.icon,
      transform = _ref.transform,
      name = _ref.name,
      id = _ref.id,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "small" : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "outline" : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color,
      hover = _ref.hover,
      _ref$svgAttrs = _ref.svgAttrs,
      svgAttrs = _ref$svgAttrs === void 0 ? {} : _ref$svgAttrs,
      title = _ref.title,
      className = _ref.className,
      noMargin = _ref.noMargin,
      isStencilHost = _ref.isStencilHost,
      showBadge = _ref.showBadge,
      badgeText = _ref.badgeText,
      horizontalAlignment = _ref.horizontalAlignment;

  var _a; // Give the icon a uniqueId if id prop not set else title id will be undefined


  var iconId = id || uniqueId("".concat(hostClass, "-")); // Use default icon description as title if title prop not set.

  var iconTitle = title || (title === null || title === void 0 ? void 0 : title.trim()) === "" && " " || (icon === null || icon === void 0 ? void 0 : icon.name) && texts.lsg.icon[icon.name] || name && texts.lsg.icon[name] || texts.lsg.icon._default;
  var iconFunction = icon || typeof window !== "undefined" && ((_a = window.lsgIcons) === null || _a === void 0 ? void 0 : _a[name]);
  var sizeNumeric = {
    small: 24,
    medium: 48,
    large: 96
  }[size];
  var iconString = iconFunction && iconFunction({
    id: iconId,
    svgAttrs: Object.assign({
      width: "".concat(sizeNumeric, "px"),
      height: "".concat(sizeNumeric, "px"),
      focusable: "false"
    }, svgAttrs),
    title: iconTitle,
    size: sizeNumeric,
    variant: variant
  }); // Badge: show a smaller badge if there's no badgeText else show a larger badge if the badgeText contains a non-empty string.
  // also: abridge the text if the text is longer than 3 characters.

  var badgeTextShortened = typeof badgeText === "string" ? badgeText.substr(0, 3) : undefined;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__align-").concat(horizontalAlignment), horizontalAlignment), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(size), size && !noMargin), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__badge"), showBadge), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(size), !!size), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(color), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__hover"), hover), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(transform), !!transform), _cleanupClassObject2)),
    dangerouslySetInnerHTML: {
      __html: iconString || "<div></div>"
    }
  }), showBadge && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-badge"), true), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "__dot"), showBadge && !badgeTextShortened), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "__broad"), showBadge && (badgeTextShortened === null || badgeTextShortened === void 0 ? void 0 : badgeTextShortened.length) > 1), _cleanupClassObject3))
  }, badgeText));
});

export { IconPresentation };
